module.exports = __webpack_public_path__ + "assets/images/android_dl_prompt-03587bc26c2d0dbed1952b15ba36c17c.webm";